import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import React from "react";

const OfferSection = () => {
  return (
    <Container
      maxWidth="lg"
      id="what_we_offer"
      sx={{ py: { xs: 6, md: 0 } }}
    >
      {/* SECTION HEADER */}
      <Box textAlign="center" mb={{ xs: 6, md: 8 }}>
        <Typography variant="h3" color="primary" fontWeight={700} gutterBottom>
          What We Offer
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 750, mx: "auto", lineHeight: 1.8 }}
        >
          A powerful digital ecosystem designed to simplify school operations,
          strengthen parent engagement, and enhance student learning through
          intelligent technology.
        </Typography>
      </Box>

      {/* FEATURES GRID */}
      <Grid container spacing={{ xs: 4, md: 6 }}>
        {[
          {
            title: "Effortless School Management",
            description:
              "Automate attendance, grading, timetables, reporting, and administrative workflows — allowing educators to focus on teaching, not paperwork.",
          },
          {
            title: "Real-Time Parent Engagement",
            description:
              "Keep parents informed with instant updates on academic progress, attendance, announcements, and school activities through our connected parent platform.",
          },
          {
            title: "AI-Powered Learning Support",
            description:
              "Provide students with intelligent academic assistance, personalized insights, and real-time doubt resolution powered by advanced AI technology.",
          },
          {
            title: "Interactive & Gamified Learning",
            description:
              "Boost engagement through skill-based quizzes, competitive challenges, and interactive learning experiences that make education enjoyable and effective.",
          },
        ].map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Paper
              elevation={0}
              sx={{
                p: 5,
                borderRadius: 4,
                border: "1px solid rgba(0,0,0,0.06)",
                boxShadow: "0 12px 35px rgba(0,0,0,0.04)",
                height: "100%",
              }}
            >
              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
              >
                {item.title}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ lineHeight: 1.8 }}
              >
                {item.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* MISSION BLOCK */}
      <Box
        mt={{ xs: 8, md: 8 }}
        textAlign="center"
      >
        <Typography
          variant="body1"
          sx={{
            maxWidth: 900,
            mx: "auto",
            lineHeight: 1.9,
            fontSize: "1.05rem",
            color: "text.secondary",
          }}
        >
          We believe in the power of technology to transform education.
          Our mission is to empower schools, engage parents, and support
          students with innovative tools that make learning smarter,
          more connected, and future-ready.
        </Typography>

        <Typography
          variant="h5"
          sx={{ mt: 3 }}
          fontWeight={700}
          color="primary"
        >
          Join us in shaping the future of connected education.
        </Typography>
      </Box>
    </Container>
  );
};

export default OfferSection;